import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "nav.expandedGroups";

const readAll = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch (_e) {
    return {};
  }
};

const writeAll = (value) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch (_e) {
    // ignore
  }
};

/**
 * Per-group expand/collapse for nav section headers, persisted per browser
 * (localStorage) so it's a personal layout preference, not synced state.
 * Groups default to expanded - matches the section header's previous
 * always-open behavior for anyone who hasn't collapsed one yet.
 */
export const useNavGroupExpand = (groupKey) => {
  const [isExpanded, setIsExpanded] = useState(() => readAll()[groupKey] !== false);

  useEffect(() => {
    setIsExpanded(readAll()[groupKey] !== false);
  }, [groupKey]);

  const toggle = useCallback(() => {
    setIsExpanded((prev) => {
      const next = !prev;
      writeAll({ ...readAll(), [groupKey]: next });
      return next;
    });
  }, [groupKey]);

  return { isExpanded, toggle };
};
